import React, { useEffect, useState } from "react";
import {
  Container,
  ModalBody,
  Modal,
} from "reactstrap";
import { DataGrid } from "@mui/x-data-grid";
import { Box, TextField } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { toast } from "react-toastify";
import { detailed_approval_list, management_approve_product } from "../../../api/requisition";
import { useDispatch } from "react-redux";
import { StorePageHeaderName } from "../../../store/pageHeader/action";

const ViewAndEdit = ({ approvalDetails }) => {
  const dispatch = useDispatch();
  dispatch(StorePageHeaderName('Approval Details Requisition'));
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [gridLoad, setGridLoad] = useState(false);
  const [approvalRows, setApprovalRows] = useState([]);
  const [rowModalValue, setRowModalValue] = useState({});
  const [newAllocatedValue, setNewAllocatedValue] = useState(0);

  const navigate = useNavigate();
  const location = useLocation();
 

  const handleButtonClick = (params) => {
    setRowModalValue(params.row);
    setNewAllocatedValue(params.row.req_qty)
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const goToApprovalRequisition = () => {
    navigate("/management/approval-requisition");
  };

  document.title = "Approval Requisition details";

  const columns = [
    {
      field: "sl_no",
      headerName: "Sl.No",
      flex: 0.5,
      resizable: false,
      sortable: false,
    },
    {
      field: "segment",
      headerName: "Segment",
      headerClassName: "table-header-background",
      headerAlign: "center",
      cellClassName: "center-aligndata",
      editable: false,
      resizable: false,
      sortable: false,
      flex: 1,
    },
    {
      field: "category",
      headerName: "Category",
      headerClassName: "table-header-background",
      headerAlign: "center",
      cellClassName: "center-aligndata",
      editable: false,
      resizable: false,
      sortable: false,
      flex: 1,
    },
    {
      field: "vertical",
      headerName: "Vertical",
      headerClassName: "table-header-background",
      headerAlign: "center",
      cellClassName: "center-aligndata",
      editable: false,
      resizable: false,
      sortable: false,
      flex: 1,
    },
    {
      field: "product_name",
      headerName: "Product Name",
      headerClassName: "break-header",
      cellClassName: "product_name_wrap",
      width: 160,
      editable: false,
      resizable: false,
      sortable: false,
      flex: 1,
      renderCell: (params) => {
        const productName = params.value;
        return (
          <div
            style={{ cursor: "pointer" }}
            onClick={() => handleButtonClick(params)}
          >
            {productName}
          </div>
        );
      },
    },
    {
      field: "req_qty",
      headerName: "PO QTY",
      headerClassName: "table-header-background",
      sortable: false,
      resizable: false,
      headerAlign: "center",
      cellClassName: "center-aligndata",
      flex: 1,
    },
    {
      field: "value",
      headerName: "Value",
      headerClassName: "table-header-background",
      sortable: false,
      resizable: false,
      headerAlign: "center",
      cellClassName: "center-aligndata",
      flex: 1,
    },
  ];

  const approvalDetailsList = async () => {
    try {
      setGridLoad(true);
      const response = await detailed_approval_list(approvalDetails.id);
      const data = response.data.requisitionProductList.map((item, index) => ({
        id: item.id,
        sl_no: index + 1,
        segment: item.itemseg,
        category: item.category,
        vertical: item.vertical,
        product_name: item.item_name,
        req_qty: item.total_qty,
        value: +(item.mop * item.total_qty * item.conversion_rate),
      }));
      
      setApprovalRows(data);
    } catch (error) {
      toast.error(
        error.message || "An error occurred while fetching detailed list"
      );
    } finally {
      setGridLoad(false);
    }
  };

  const handleAllocationQtyChange = (value) => {
    setNewAllocatedValue(value);
  };

  const handleModalSubmit = async () => {
    try {
      if(newAllocatedValue === 0){
        toast.error('Sorry 0 cannot be assigned');
      } else {
        const productDistId = rowModalValue.id;
        const payload = {
            product_dist_id: productDistId,
            updated_qty: newAllocatedValue
        }
        await management_approve_product(payload);
        toast.success('Product approved successfully');
        approvalDetailsList();
      }
    } catch (error) {
      toast.error(error.message || "Quantity update failed");
    } finally {
      setModalIsOpen(false);
    }
  };

  useEffect(() => {
    approvalDetailsList();
  }, []);
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div>
            <Box
              sx={{
                height: '100%',
                width: "100%",
                marginBottom: "10px",
                marginTop: "10px",
              }}
            >
              <DataGrid
                 autoHeight
                className="table_header_background"
                headerClassName="custom-header-cell"
                rows={approvalRows}
                columns={columns}
                loading={gridLoad}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 5,
                    },
                  },
                }}
                pageSizeOptions={[5]}
                disableRowSelectionOnClick
                disableColumnMenu
                disableColumnResize={true}
                componentsProps={{
                  cell: {
                    disableClick: true,
                  },
                }}
                sx={{
                  "& .MuiDataGrid-cell": {
                    "& .MuiDataGrid-cell--textOverflow": {
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    },
                  },
                }}
              />
            </Box>
          </div>
        </Container>
      </div>
      <Modal isOpen={modalIsOpen} onRequestClose={closeModal}>
        <div className="d-flex justify-content-between me-2 mt-3">
          <h4 className="ms-3">{rowModalValue?.product_name}</h4>
          <div className="d-flex justify-content-end me-3 modal_close">
            <i class="ri-close-line" onClick={closeModal}></i>
          </div>
        </div>
        <hr className="mb-2 mt-1 ms-3 me-3"></hr>
        <ModalBody className="pt-2">
          <div>
            <div className="d-flex align-items-center justify-content-center">
              <TextField
                type="number"
                className="create_requisition_textfield"
                label="Quantity"
                variant="outlined"
                value={newAllocatedValue.toString().replace(/^0+/, '') || '0'}
                onChange={(event) => {
                  const value = Number(event.target.value);
                  const maxValue = rowModalValue?.req_qty || 0;
                  handleAllocationQtyChange(
                    value >= 0 && value > maxValue ? maxValue : value
                  );
                }}
                inputProps={{ min: 0, max: rowModalValue?.req_qty || 0 }}
                sx={{ width: "240px" }}
              />
            </div>
            <div className="d-flex align-items-center mt-4 justify-content-center">
              <button className="yes_button" onClick={handleModalSubmit}>
                Done
              </button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default ViewAndEdit;
